var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FlexBox, Spinner, Text } from '@dixa/lib-shared-habla';
import { colors, sizes } from '@dixa/lib-shared-tokens';
export function KnowledgeLoading(props) {
    const { width = '100%', height = '100%', size = 56 } = props, rest = __rest(props, ["width", "height", "size"]);
    return (_jsxs(FlexBox, Object.assign({ style: { width, height, display: 'inline-flex' }, justifyContent: "center", alignItems: "center", flexDirection: "column", background: colors.neutral['000'] }, { children: [_jsx(Spinner, Object.assign({}, rest, { size: size })), props.text && (_jsx("div", Object.assign({ style: { padding: sizes.spacer[300] } }, { children: _jsx(Text.Paragraph, { children: props.text }) })))] })));
}
